import { z } from 'zod';
import {
  PAGINATION_PAGE_SIZE_DEFAULT,
  PAGINATION_SORT_DIRECTION,
} from '~/constants';

import { toSnakeCase, withoutObjectKeysWhereValueIs } from '@vestigas/utils';

import { API_POLLER_SECRETS_ORDER_BY } from './constants';

export const zodApiPollerSecretsBaseSchema = z.object({
  // Filter fields
  isActive: z.boolean().nullable().optional(),
  issuerCompanyAccountId: z.uuid().optional(),
  issuerId: z.uuid().optional(),
  latestVersionOnly: z.boolean().optional().prefault(true),
  pollingProblem: z.boolean().nullable().optional(),
  searchString: z.string().prefault(''),

  // Pagination fields
  limit: z
    .number()
    .gte(1)
    .max(100)
    .optional()
    .prefault(PAGINATION_PAGE_SIZE_DEFAULT),
  offset: z.number().nonnegative().optional().prefault(0),

  // Sorting fields
  sortBy: z
    .preprocess(
      (value) => (typeof value === 'string' ? toSnakeCase(value) : value),
      z.enum(API_POLLER_SECRETS_ORDER_BY),
    )
    .optional()
    .default('last_successful_run'),
  sortOrder: z
    .preprocess(
      (value) => String(value).toUpperCase(),
      z.enum(PAGINATION_SORT_DIRECTION),
    )
    .optional()
    .default('DESC'),
});

export const zodApiPollerSecretsQueryParamsSchema =
  zodApiPollerSecretsBaseSchema.transform((value) =>
    withoutObjectKeysWhereValueIs(value, [null, undefined, '']),
  );

export type ApiPollerSecretsQueryParams = z.infer<
  typeof zodApiPollerSecretsQueryParamsSchema
>;
